import { render, staticRenderFns } from "./RecommendItems.vue?vue&type=template&id=7ef00f2b&"
import script from "./RecommendItems.vue?vue&type=script&lang=ts&"
export * from "./RecommendItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports